import React, {useMemo} from 'react';
import SourcePackage from '../../../../components/sourcePackage/SourcePackage';
import AIAssistant from '../../reportEditorPage/leftPanel/AIAssistant';
import {useEditorLeftPanelTabs, useLeftPanelSync} from '../../hooks';
import LeftPanelTabs from '../../components/common/LeftPanelTabs';
import AIAssistantChatTab from '../../components/common/AIAssistantChatTab';
import UnifiedSearchSection from "../../reportEditorPage/leftPanel/components/UnifiedSearchSection";
import SimilarPitchesSection from './SimilarPitchesSection';

const PitchLeftPanel = () => {
    const {leftPanelTab, setLeftPanelTab, setAiView} = useLeftPanelSync();

    const tabs = useMemo(() => ([
        {
            value: 'search',
            label: 'Sources',
            content: (
                <UnifiedSearchSection
                    hostId="pitch-left-panel-search"
                    isActive={leftPanelTab === 'search'}
                />
            ),
        },
        // {value: 'sources', label: 'Sources', content: <SourcesSection isActive={leftPanelTab === 'sources'}/>},
        {value: 'sourcePackage', label: 'Source Package', content: <SourcePackage/>},
        {value: 'chat', label: 'Chat', content: <AIAssistantChatTab isActive={leftPanelTab === 'chat'}/>},
        {value: 'aiAssistant', label: 'AI Assistant', content: <AIAssistant/>},
        // {value: 'topic', label: 'Topic', content: <TopicSection/>}
        {
            value: 'similarPitches',
            label: 'Similar Pitches',
            content: <SimilarPitchesSection isActive={leftPanelTab === 'similarPitches'}/>
        },
    ]), [leftPanelTab]);

    const {handleTabChange} = useEditorLeftPanelTabs({
        tabs,
        leftPanelTab,
        setLeftPanelTab,
        setAiView,
    });

    return (
        <LeftPanelTabs
            tabs={tabs}
            activeTab={leftPanelTab}
            onChange={handleTabChange}
            ariaLabel="Pitch left panel tabs"
        />
    );
};

export default PitchLeftPanel;

